import { ApiResponseSerializer } from '@v2/commons/interface/ApiResponseSerializer'
import { rootApi } from '@v2/store/api/rootApi'

import { AddMessageMutation, IMessage } from '../types/chat.types'

export const CHAT_MESSAGES_TAG = {
  chatMessagesTag: 'CHAT_MESSAGES',
}

export const chatApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getChatMessages: builder.query<ApiResponseSerializer<IMessage>, string>({
      query: (chatId) => ({
        url: `/v1/chat/messages/${chatId}?orderBy=createdAt%20DESC`,
        method: 'GET',
      }),
      providesTags: [CHAT_MESSAGES_TAG.chatMessagesTag],
    }),
    addChatMessage: builder.mutation<IMessage, { data: AddMessageMutation }>({
      query: ({ data }) => ({
        url: '/v2/chat/message/add',
        method: 'POST',
        data,
      }),
      invalidatesTags: [CHAT_MESSAGES_TAG.chatMessagesTag],
    }),
  }),
})

export const { useGetChatMessagesQuery, useAddChatMessageMutation } = chatApi
